import { render, staticRenderFns } from "./AutorizacaoSuporte.vue?vue&type=template&id=a0a7d462&scoped=true&"
import script from "./AutorizacaoSuporte.vue?vue&type=script&lang=js&"
export * from "./AutorizacaoSuporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a7d462",
  null
  
)

export default component.exports